import { Component, Input } from "@angular/core"
import { SubSectionPubDTO } from "@services/program.published.service"

@Component({
  selector: "app-sub-section",
  standalone: true,
  imports: [],
  templateUrl: "./sub-section.component.html",
  styleUrl: "./sub-section.component.scss",
})
export class SubSectionComponent {
  textEmpty = false

  @Input() _subSection: SubSectionPubDTO | undefined
  @Input() set subSection(sub: SubSectionPubDTO | undefined) {
    this._subSection = sub

    const dom = document.createElement("div")
    dom.innerHTML = sub?.content || ""
    this.textEmpty = dom.textContent === ""
  }
}
